import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  height: 16px;
  width: 16px;
`

export const CircleIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#00C875" />
    </Svg>
  )
}
